<input
    type="password"
    [readonly]="readonly"
    [formControl]="formControl"
/>
